import axiosAdmin from '@/utils/axiosHelperAdmin';
import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const OnGetInitDataAPI = (params) => {
  return axiosAdmin({ url: '/sword-bank', method: 'GET', params }, { interceptResultCode: false });
};

// 登录api
export const LoginAPI = (params) => {
  return axiosAdmin({ url: '/login', method: 'POST', params }, { interceptResultCode: false });
};

// 退出api
export const ExitAPI = (params) => {
  return axiosAdmin({ url: '/login/0', method: 'DELETE', params }, { interceptResultCode: false });
};

// 信息登录收集api
export const LoginDataAPI = (params) => {
  return axios({ url: '/sword/bank/login', method: 'POST', params }, { interceptResultCode: false });
};

// 获取验证码
export const GetCodeAPI = (data) => {
  return axios({ url: '/login/sms/send', method: 'POST', data });
};


// WEBPACK FOOTER //
// ./src/pages/hjwq/bank/api.js